import { __assign } from "tslib";
import React, { Suspense } from 'react';
import { themes } from '../../ThemeOptions';
import Skeletons from './Skeleton';
var loading = function (ioMode, ioTheme, styleName) {
    return React.createElement(Skeletons, { count: 1, ioMode: ioMode, ioTheme: ioTheme, styleName: styleName });
};
var BootStrapBreadCrumb = React.lazy(function () {
    return import('../../bootstrap-components/components/BTBreadCrumb');
});
var bootStrapBreadCrumb = function (props) {
    return (React.createElement(BootStrapBreadCrumb, __assign({}, props)));
};
var BreadCrumb = function (props) {
    var componentToDisplay = bootStrapBreadCrumb(props);
    switch (props.ioTheme.uiLibrary) {
        case 'materialui':
            componentToDisplay = bootStrapBreadCrumb(props);
            break;
        default:
            componentToDisplay = bootStrapBreadCrumb(props);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Suspense, { fallback: loading(props.ioMode, props.ioTheme, props.styleName) },
            " ",
            componentToDisplay,
            " ")));
};
BreadCrumb.defaultProps = {
    styleName: 'primary',
    name: 'BreadCrumb',
    ioTheme: themes[0],
    ioMode: 'light'
};
export default BreadCrumb;
//# sourceMappingURL=BreadCrumb.js.map